<template>
  <div>
    <form @submit="submitResultForm" action="/">
      <v-container class="pa-0">
        <p class="mb-0 caption grey--text text-uppercase" v-if="matchDate && matchDate.day_hint">
          {{ matchDate.day_hint }}
          {{ matchDate.starts_at ? format(new Date(matchDate.starts_at), 'd.M.y HH:mm') : '' }}
          {{ matchDate.ends_at ? `- ${format(new Date(matchDate.ends_at), 'd.M.y HH:mm')}` : '' }}
        </p>
        <v-row no-gutters>
          <v-col cols="6" @click.stop="matchClicked()">
            <div
                :class="{ 'winner': firstTeamWon(result), 'highlighted': goalsHasFocus, 'darker' : opponentGoalsHasFocus}">
              <player-or-team-name :player="player" :showIdOfPlatform="showIdOfPlatform" />
              <span v-if="player.type != 'team'">
              <twitch-sign v-if="getExternalAccount(playerProfile, 'twitch')" driver="twitch" /><twitch-sign
                  v-if="getExternalAccount(playerProfile, 'youtube')" driver="youtube" />
            </span>
              <br v-if="$vuetify.breakpoint.smAndDown">
              <span v-if="player.nominatedPlayer" class="caption grey--text">
              {{ player.nominatedPlayer.name }}
            </span>
            </div>
            <div
                :class="{ 'winner': secondTeamWon(result), 'highlighted': opponentGoalsHasFocus, 'darker' : goalsHasFocus}">
              <player-or-team-name :player="opponent" :showIdOfPlatform="showIdOfPlatform" />
              <span v-if="player.type != 'team'">
              <twitch-sign v-if="getExternalAccount(opponentProfile, 'twitch')" driver="twitch" /><twitch-sign
                  v-if="getExternalAccount(opponentProfile, 'youtube')" driver="youtube" />
            </span>
              <br v-if="$vuetify.breakpoint.smAndDown">
              <span v-if="opponent.nominatedPlayer" class="caption grey--text">
              {{ opponent.nominatedPlayer.name }}
            </span>
            </div>
          </v-col>
          <v-col cols="2" class="text-center" @click.stop="resultClicked()">
          <span
              v-if="result"
              class="display-1"
              :class="{ 'winner': firstTeamWon(result)}"
          >{{ result.goals }}</span>
            <v-text-field
                v-else-if="editable && !forceDialog"
                v-model="goals"
                :id="uid + '_p'"
                type="number"
                class="no-field-details"
                filled
                :min="0"
                :max="999"
                @focus="goalsHasFocus = true"
                @blur="goalsHasFocus = false"
                :rules="goalRules"
                :loading="hasPendingRequest"
                :disabled="hasPendingRequest || disabled"
            ></v-text-field>
            <div v-if="editable && !forceDialog && inputState.any && !hasPendingRequest">
              <v-btn
                  tabindex="-1"
                  @click="clearInput"
                  rounded
                  class=""
                  :disabled="hasPendingRequest"
                  style="min-width: 30px;padding: 0; width: 100%;"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="(!forceDialog || this.result) || (forceDialog && !this.editable)" cols="1"
                 class="display-1 text-center" @click.stop="matchClicked()">:
          </v-col>
          <v-col cols="2" class="text-center" @click.stop="resultClicked()">
            <div v-if="result" style="display:inline;position:relative;">
          <span
              class="display-1"
              :class="{ 'winner': secondTeamWon(result)}"
          >{{ result.opponent_goals }}</span>
              <div style="position:absolute;top:-1em;right:-12px;" v-if="result.confirmedAt">
                <sup>
                  <v-icon small class="confirmedCheck">mdi-check-circle</v-icon>
                </sup>
              </div>
            </div>
            <v-text-field
                v-else-if="editable && !forceDialog"
                v-model="opponentGoals"
                :id="uid + '_o'"
                type="number"
                :min="0"
                :max="999"
                class="no-field-details"
                filled
                @focus="opponentGoalsHasFocus = true"
                @blur="opponentGoalsHasFocus = false"
                :rules="goalRules"
                :loading="hasPendingRequest"
                :disabled="hasPendingRequest || disabled"
            ></v-text-field>
            <div v-if="editable && !forceDialog && (inputState.any || isResetInputState)">
              <v-btn
                  type="submit"
                  rounded
                  class="primary"
                  :disabled="hasPendingRequest"
                  style="min-width: 30px;padding: 0; width: 100%;"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col v-if="forceDialog && this.editable" cols="1" class="display-1 text-center">
            <v-btn class="primary" icon @click.stop="matchClicked()">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <input type="hidden" name="playerUID" :value="player.uid" />
      <input type="hidden" name="opponentUID" :value="opponent.uid" />
      <input type="submit" style="visibility:hidden;position:absolute;" />
    </form>
    <div class="mt-4" v-if="!forceDialog && this.game.type === 'ko.mixed'">
      <p class="subtitle-1">Einzelspiele</p>
      <p class="text-secondary small">
        Bitte nutzen Sie den Chat um die jeweiligen Spielerpaarungen festzulegen.
      </p>
      <v-btn class="mb-2" v-if="!this.chatOpen" color="primary" @click="$emit('openChat')">Chat öffnen</v-btn>

      <div class="mt-2" v-for="(singleGame, index) in this.mixedCoopResults" :key="index">
        <v-row class="ml-1">
          <v-icon class="mr-1">mdi-gamepad-variant</v-icon>
          <span>Spiel {{ index + 1 }}</span>
        </v-row>
        <v-row>
          <v-col>
            <p>
             {{player.name}} Spieler {{ index + 1}}
            </p>
          </v-col>
          <v-col cols="2" class="text-center" @click.stop="resultClicked()">
            <v-text-field
                v-model="singleGame.goals"
                :id="uid + '_p' + index"
                type="number"
                class="no-field-details"
                filled
                dense
                :min="0"
                :max="999"
                @focus="goalsHasFocus = true"
                @blur="goalsHasFocus = false"
                :rules="goalRules"
                :loading="hasPendingRequest"
                :disabled="hasPendingRequest || resultConfirmed"
            ></v-text-field>
          </v-col>
          <v-col cols="1"
                 class="display-1 text-center" @click.stop="matchClicked()">:
          </v-col>
          <v-col cols="2" class="text-center" @click.stop="resultClicked()">
            <v-text-field
                v-model="singleGame.opponent_goals"
                :id="uid + '_o'"
                type="number"
                :min="0"
                :max="999"
                class="no-field-details"
                filled
                dense
                @focus="opponentGoalsHasFocus = true"
                @blur="opponentGoalsHasFocus = false"
                :rules="goalRules"
                :loading="hasPendingRequest"
                :disabled="hasPendingRequest || resultConfirmed"
            ></v-text-field>
          </v-col>
          <v-col><p> {{opponent.name}} Spieler {{ index + 1}} </p></v-col>
          <v-col cols="1">
            <v-btn
                @click="submitMixedResult(index)"
                rounded
                class="primary"
                :disabled="hasPendingRequest ||resultConfirmed"
                style="min-width: 30px;padding: 0; width: 100%;"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from '@/plugins/store'
import { EVENT_GAME_RESULT_ADDED, EVENT_SCHEDULES_AVAILABLE } from '@/plugins/eventbus'
import TwitchSign from './TwitchSign.vue'
import PlayerOrTeamName from './PlayerOrTeamName.vue'
import { format } from 'date-fns'

export default {
  name: 'ScheduleMatch',
  components: {
    TwitchSign,
    PlayerOrTeamName
  },
  props: {
    uid: {
      type: String,
      required: true
    },
    player: {
      type: Object,
      required: true
    },
    opponent: {
      type: Object,
      required: true
    },
    matchDate: {
      type: Object,
      required: false
    },
    result: {
      type: Object,
      required: false
    },
    singleGames: {
      type: Array,
      required: false
    },
    initialGoals: {
      type: Number,
      required: false
    },
    initialOpponentGoals: {
      type: Number,
      required: false
    },
    game: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    forceDialog: {
      type: Boolean,
      default: false
    },
    showIdOfPlatform: {
      type: String,
      default: undefined
    },
    chatOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      goals: undefined,
      goalsHasFocus: false,
      opponentGoals: undefined,
      opponentGoalsHasFocus: false,
      mixedCoopResults: [],
      saving: false,
      goalRules: [
        v =>
            v == '' || v == undefined || v == null || (v >= 0 && !isNaN(v)) || ''
      ]
    }
  },
  mounted() {
    this.goals = this.initialGoals
    this.opponentGoals = this.initialOpponentGoals
    if (this.game.type === 'ko.mixed') {
      this.mixedCoopResults = this.singleGames ? this.singleGames : [this.defaultSingleGameResultObject(), this.defaultSingleGameResultObject()]
      if (this.mixedCoopResults.length === 1) {
        this.mixedCoopResults = [...this.mixedCoopResults, this.defaultSingleGameResultObject()]
      }
    }
  },
  computed: {
    hasPendingRequest() {
      return this.loading || this.saving
    },
    resultConfirmed() {
      return this.result ? !!this.result.confirmedAt : false
    },
    inputState() {
      let bGoals = this.goals && this.goals != ''
      let bOpponentGoals = this.opponentGoals && this.opponentGoals != ''
      return {
        uid: this.uid,
        any: (bGoals || bOpponentGoals) == true,
        both: bGoals && bOpponentGoals,
        goals: this.goals,
        opponentGoals: this.opponentGoals
      }
    },
    isResetInputState() {
      // when initial goals are set and all values have been removed
      return this.inputState.any == false && (this.initialGoals || this.initialOpponentGoals)
    },
    playerProfile() {
      return this.reresolvePlayerFromParticipants(this.player)
    },
    opponentProfile() {
      return this.reresolvePlayerFromParticipants(this.opponent)
    }
  },
  watch: {
    goals: function () {
      this.updateInputState()
    },
    singleGames: function (newVal) {
      if (newVal) {
        this.mixedCoopResults = newVal
      }
      this.updateInputState()
    },
    opponentGoals: function () {
      this.updateInputState()
    },
    result: function (newVal) {
      if (newVal) {
        this.goals = newVal.goals
        this.opponentGoals = newVal.opponent_goals
      } else {
        this.goals = undefined
        this.opponentGoals = undefined
      }
    }
  },
  methods: {
    format: format,
    defaultSingleGameResultObject() {
      return { goals: null, opponent_goals: null }
    },
    reresolvePlayerFromParticipants(player) {
      let playerFromParticipants = this.game.participants.find((e) => {
        return e.uid == player.uid
      })
      return playerFromParticipants ? playerFromParticipants : player
    },
    getExternalAccount(player, driver) {
      if (!player.externalAccounts) {
        return undefined
      }
      return player.externalAccounts.find(function (ext) {
        return ext.driver == driver
      })
    },
    updateInputState() {
      this.$emit('userInput', this.inputState)
    },
    clearInput() {
      this.goals = undefined
      this.opponentGoals = undefined
    },
    submitResultForm(e) {
      e.preventDefault()
      let formEl = e.target
      this.submitResultFormData(formEl)
      return false
    },
    submitResultFormData(formEl) {
      let formData = new FormData(formEl)
      var goals = this.goals
      var opponentGoals = this.opponentGoals
      if (this.isResetInputState) {
        this.resetSoccerResult()
        return
      }
      if (
          goals === '' ||
          opponentGoals === '' ||
          isNaN(goals) ||
          isNaN(opponentGoals)
      ) {
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
          message: 'Es müssen zwei gültige Ergebnisse eingetragen werden',
          type: 'warning'
        })
        return
      }
      goals = parseInt(goals)
      opponentGoals = parseInt(opponentGoals)
      if (goals < 0 || opponentGoals < 0) {
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
          message: 'Es müssen zwei gültige Ergebnisse eingetragen werden',
          type: 'warning'
        })
        return
      }

      let playerUID = formData.get('playerUID')
      let opponentUID = formData.get('opponentUID')

      this.addSoccerResult(playerUID, opponentUID, goals, opponentGoals)
    },

    submitMixedResult(index) {
      this.saving = true
      const data = {
        ...this.mixedCoopResults[index],
        match_uid: this.uid,
        single_game_index: index + 1,
        player_uid: this.player.uid,
        opponent_uid: this.opponent.uid
      }
      this.$api
          .addMixedGaminstanceSingleResult(this.game, data)
          .then((res) => {
            this.handleUpdateScheduleAfterRequest(res.data)
            this.$emit('matchStored', {
              matchUid: this.uid,
              uid: this.player?.uid,
              opponent_uid: this.opponent?.uid,
              goals: this.initialGoals + this.mixedCoopResults[index].goals,
              opponent_goals: this.initialOpponentGoals + this.mixedCoopResults[index].opponent_goals
            })
          })
          .catch(error => {
            this.saving = false
            this.$common.onError(error)
          })
    },
    addSoccerResult(playerUID, opponentUID, goals, opponentGoals) {
      if (playerUID === undefined) throw new Error('playerUID not set')
      if (opponentUID === undefined) throw new Error('opponentUID not set')
      if (goals === undefined) throw new Error('goals not set')
      if (opponentGoals === undefined) throw new Error('opponentGoals not set')
      let data = {
        matchUid: this.uid,
        uid: playerUID,
        opponent_uid: opponentUID,
        goals: goals,
        opponent_goals: opponentGoals
      }
      // console.log("Submitting", data);
      this.saving = true
      this.$api
          .addGameInstanceSoccerResult(this.game, data)
          .then((res) => {
            console.log('result added', res.data)
            this.handleUpdateScheduleAfterRequest(res.data)
            this.$emit('matchStored', data)
          })
          .catch(error => {
            this.saving = false
            this.$common.onError(error)
          })
    },

    resetSoccerResult() {
      let data = {
        matchUid: this.uid
      }
      // console.log("Submitting", data);
      this.saving = true
      this.$api
          .resetGameInstanceSoccerResult(this.game, data)
          .then((res) => {
            console.log('reset performed', res.data)
            this.saving = false
            this.goals = undefined
            this.opponentGoals = undefined
            this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
              message: this.$t('scheduleMatch.result-reseted'),
              type: 'success'
            })
            if (res.data && res.data.schedules) {
              this.$eventBus.$emit(EVENT_SCHEDULES_AVAILABLE, {
                gameuid: this.game.uid,
                schedules: res.data.schedules
              })
            }
            this.$eventBus.$emit(EVENT_GAME_RESULT_ADDED, {
              gameuid: this.game.uid
            })
            this.$emit('matchStored', data)
          })
          .catch(error => {
            this.saving = false
            this.$common.onError(error)
          })
    },

    matchClicked() {
      this.$emit('matchClicked', { uid: this.uid, result: this.result })
    },

    resultClicked() {
      if (this.result || this.forceDialog) {
        this.$emit('matchClicked', { uid: this.uid, result: this.result })
      }
    },

    firstTeamWon(result) {
      return result && result.goals > result.opponent_goals
    },
    secondTeamWon(result) {
      return result && result.goals < result.opponent_goals
    },
    handleUpdateScheduleAfterRequest(responseData) {
      this.saving = false
      this.goals = undefined
      this.opponentGoals = undefined
      this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
        message: this.$t('scheduleMatch.result-stored'),
        type: 'success'
      })
      if (responseData && responseData.schedules) {
        this.$eventBus.$emit(EVENT_SCHEDULES_AVAILABLE, {
          gameuid: this.game.uid,
          schedules: responseData.schedules
        })
      }
      this.$eventBus.$emit(EVENT_GAME_RESULT_ADDED, {
        gameuid: this.game.uid
      })
    }
  }
}
</script>

<style scoped>
.winner {
  color: var(--v-primary-base);
  text-shadow: 0 0 5px var(--v-primary-darken1), 0 0 10px var(--v-primary-darken1),
  0 0 30px var(--v-primary-darken1), 0 0 35px var(--v-primary-darken1);
}

.highlighted {
  color: white;
  text-shadow: 0 0 5px white, 0 0 10px white, 0 0 15px white;
}

.darker {
  color: inherit;
}

.no-field-details >>> .v-text-field__details {
  display: none;
}

.confirmedCheck {
  color: var(--v-primary-base);
}
</style>
